import { Component } from '@angular/core';

@Component({
  selector: 'fnsr-checks',
  templateUrl: './checks.component.html'
})
export class ChecksComponent{

}
